// @flow

import { LoadingPayment } from './loading-payment';

export default LoadingPayment;
export { LoadingPayment };
